module.exports = __webpack_public_path__ + "static/media/web-automation-with-python-language.7446eedb.md";